import React from 'react';
import PropTypes from 'prop-types';
import { TextInput } from '../styles';

const { object, number, string } = PropTypes;

const TextQuestion = (props) => {
  const { field, fieldName, form, bookingId, experienceQuestionId, guestId } =
    props;

  const handleInput = (event) => {
    const value = form.values[fieldName];
    form.setFieldValue(fieldName, {
      bookingId,
      experienceQuestionId,
      textAnswer: event.target.value,
      id: value?.id,
      guestId,
    });
  };
  const value = field.value || {};
  const { textAnswer } = value;
  return <TextInput type="text" value={textAnswer} onChange={handleInput} />;
};

TextQuestion.propTypes = {
  value: object,
  fieldName: string.isRequired,
  form: object.isRequired,
  bookingId: number.isRequired,
  experienceQuestionId: number.isRequired,
};

export default TextQuestion;
